import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { Observable } from 'rxjs/internal/Observable';
import { HttpEvent } from '@angular/common/http';

@Injectable()
export class AlarmService {
  private $api: string = '';

  constructor(private $ajax: AjaxService) {
    this.$api = $ajax.getAPIDomain();
  }

  /**
   * 사용자가 설정한 알람 초기화
   */
  clearAlarms(): Observable<HttpEvent<any>> {
    return this.$ajax.httpRequest(
        'DELETE',
        this.$api + `user/alarms`,
    );
  }

  /**
   * 설정할 수 있는 알람 시간 목록 반환
   */
  getMiscellaneousAlarms(): Promise<{
    minute: number,
  }[]> {
    return this.$ajax.httpRequest(
        'GET',
        this.$api + 'miscellaneous/alarms',
    ).toPromise();
  }

  /**
   * 사용자가 설정한 알람 목록 반환
   */
  getAlarms(): Promise<{
    minute: number,
  }[]> {
    return this.$ajax.httpRequest(
        'GET',
        this.$api + `user/alarms`,
    ).toPromise();
  }

  /**
   * 알람 등록
   * @param {number} minute 알람 시간
   * @return {Observable<any>}
   */
  registerAlarm(minute): Observable<HttpEvent<any>> {
    return this.$ajax.httpRequest(
        'POST',
        this.$api + `user/alarms`,
        { minute },
    );
  }

  /**
   * 알람 제거
   * @param {number} minute 알람 시간
   * @return {Observable<any>}
   */
  deregisterAlarm(minute): Observable<HttpEvent<any>> {
    return this.$ajax.httpRequest(
        'DELETE',
        this.$api + `user/alarms/${minute}`,
    );
  }
}
